import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { Reviews } from './components/Reviews';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { MentionsLegales } from './components/MentionsLegales';
import { PageSEO, LocalBusinessSchema } from './components/SEO';
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* SEO pour la page d'accueil */}
      <PageSEO 
        title={null}
        description="Prothésiste ongulaire à domicile à La Réunion. Extensions, semi-permanent et nail art. Service chez vous à Ravine des Cabris, Saint-Pierre, Le Tampon. Prendre RDV sur WhatsApp."
      />
      <LocalBusinessSchema />
      
      <Header />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <FloatingCTA />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
